import { MediaType } from '../../../constants/MediaType';
export function toFolder() {
  return {
    id: 'FacebookVideo',
    name: 'FacebookVideo',
    mediaType: MediaType.Video,
    parentId: null,
    filesCount: null,
    createdAt: null
  };
}